// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import CommandBox from '../components/CommandBox';
import ShowImg from '../components/ShowImg';

// img
import singleDownloadImg from '../img/download_img.png';
import figureImgS3 from '../img/Figure_S3.png';
import figureImgS4 from '../img/Figure_S4.png';

function Gaap07(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title">Genome annotation</h2>
            <h2 className="content_title2">Structural annotation</h2>
            <h2 className="contnet_description">(3) Evidence-driven prediction of gene structure</h2>
            <div className="content_text">
                Recent methods are being used to predict gene structure 
                based on external evidence. The evidence-driven method 
                uses results, obtained by aligning expressed sequence tags 
                (ESTs), protein sequences, and RNA-Seq data to a genome assembly, 
                as external evidence. GAAP uses Maker as an evidence-driven gene 
                predictor and GBrowse as a visualization tool.
            </div>
            <div className="content_command_title">Maker</div><br/>
            <div className="content_text">
                MAKER is a pipeline tool that combines several software 
                tools in one; these tools include RepeatMasker, 
                Exonerate, SNAP, Augustus, and Blast.
            </div>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="http://www.yandell-lab.org/software/maker.html" /><br/>
                </div>
            </div><br/>
            <li className="content_description">Configuration Files</li>
            <div className="content_text">
                Before running the Maker command, various 
                parameters need to be set in MAKER configuration 
                files (maker_exe.ctl, maker_bopts.ctl, and maker_opt.ctl).
            </div>
            <li className="content_description">Options for Augustus</li>
            <OptionTable
                data={[
                    {   option:'maker_exe.ctl',
                        desc:`set the installation pathways for the programs used 
                            to run each program contained within MAKER (RepeatMasker, 
                            Exonerate, SNAP, Augustus, and Blast)`},
                    {   option:'maker_bopts.ctl',
                        desc:`set the thresholds for statistics filtering in the 
                            programs Blastn, Blastx, and Exonerate`},
                    {   option:'maker_opt.ctl',
                        desc:`set the information on the location of input files 
                            and on some of the parameters controlling decision 
                            making during the gene prediction`},
                ]}
            /><br />
            <li className="content_description">Maker Command</li>
            <CommandBox lines={[
                {data:
                    `maker`
                },
            ]}
            /><br/>
            <li className="content_description">Output of Maker</li>
            <div className="content_text">
                maker.gff3: stores information about the number of genes predicted 
                in the corresponding scaffolds, the locations of these genes, 
                and the introns, exons, CDSs&nbsp;
                <ShowImg name="(Supplementary Figure S3)"
                        src= {figureImgS3}
                />.
            </div><br/>
            <div className="content_command_title">GBrowse</div><br/>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="https://sourceforge.net/projects/gmod/files" /><br/>
                </div>
            </div><br/>
            <div className="content_text">
                The results obtained via Maker can be inspected 
                visually using GBrowse. GBrowse shows gene structure 
                predicted by each of the individual programs
                (SNAP, Augustus, Exonerate, Blast, MAKER)&nbsp;
                <ShowImg name="(Supplementary Figure S4)"
                        src= {figureImgS4}
                />.
            </div>
            <div className="content_buttons_div">
                <Link to="/Gaap06"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap08"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap07;